export const askDostEs = {
  // ask_dost: `Preguntar a Dost`,
  good_greeting: `Buenos {{greeting}}`,
  morning: `días`,
  afternoon: `tardes`,
  evening: `noches`,
  "how_can_i_help_you_today?": `¿Cómo puedo ayudarte hoy?`,
  new_ai_chat: `Nuevo chat con IA`,
  unable_to_clear_chat: `No se pudo borrar el historial del chat`,
  unable_to_send_confirmation: `No se pudo enviar la confirmación`,
  thinking: `Pensando`,
  thought_process: `Proceso de pensamiento`,
  running_tool: `Ejecutando {{tool}}...`,
  tool_completed: `{{tool}} completado`,
  tool_failed: `{{tool}} falló`,
  confirmation_required: `Confirmación requerida`,
  approve: `Aprobar`,
  reject: `Rechazar`,
  accept: `Aceptar`,
  approved: `{{confirmTool}} creado - verlo en la página de {{confirmTool}}`,
  rejected: `{{confirmTool}} cancelado`,
  attach_file: `Adjuntar archivo`,
  unable_to_upload_file: `No se pudo subir {{fileName}}`,
  invalid_file_type: `{{fileName}} no es un tipo de archivo compatible. Los tipos permitidos son PDF, CSV y XLSX`,
  duplicate_file: `{{fileName}} ya ha sido agregado`,
  upload_limit_exceeded: `No se pudo subir el documento debido al tamaño límite excedido`,
  too_many_files_error: `Demasiados archivos en esta conversación. Inicia una nueva conversación para adjuntar más.`,
  list_vendors: `Listar proveedores`,
  get_input_mappings: `Obtener asignaciones de entrada`,
  get_documents: `Obtener documentos`,
  new_chat: `Nuevo chat`,
  expand: `Expandir`,
  collapse: `Contraer`,
  close: `Cerrar`,
  copy: `Copiar`,
  copied: `¡Copiado!`,
  regenerate: `Regenerar`,
  show_less: `Mostrar menos`,
  show_more: `Mostrar más`,
  something_went_wrong: `Algo salió mal`,
  count_documents: `Contar documentos`,
  cancel: `Cancelar`,
  send_message: `Enviar mensaje`,
  there: `allí`,
  quick_action_documents: {
    label: `Documentos`,
    prompt_1: `Muéstrame todas las facturas pendientes de revisión`,
    prompt_2: `¿Qué documentos no se pudieron registrar en el ERP?`,
    prompt_3: `Muéstrame todas las facturas recibidas esta semana y su estado`,
    prompt_4: `Encuentra todos los documentos con discrepancias`,
    prompt_5: `Exporta la factura procesada más reciente del proveedor [nombre del proveedor]`,
  },

  quick_action_mappings: {
    label: `Mapeos`,
    prompt_1: `Muéstrame todos los mapeos de entrada activos`,
    prompt_2: `Quiero crear un nuevo mapeo, ayúdame a configurarlo`,
    prompt_3: `Guíame para crear un mapeo para un nuevo proveedor`,
    prompt_4: `Ayúdame a configurar una regla de mapeo para un tipo de documento específico`,
    prompt_5: `¿Cómo puedo cargar mapeos de forma masiva?`,
  },

  quick_action_workflows: {
    label: `Flujos de trabajo`,
    prompt_1: `Muéstrame todos los flujos de aprobación pendientes`,
    prompt_2: `Crea un flujo de aprobación para facturas superiores a 10.000 €`,
    prompt_3: `¿Qué facturas están esperando aprobación en este momento?`,
    prompt_4: `Quiero crear un nuevo flujo de aprobación, ¿por dónde empiezo?`,
    prompt_5: `¿Qué flujos de trabajo tenemos activos actualmente?`,
  },

  quick_action_analytics: {
    label: "Analítica",
    prompt_1: "Dame un informe resumido de la actividad de documentos de hoy",
    prompt_2:
      "Muéstrame un gráfico de cuántos documentos están pendientes de revisión en este momento.",
    prompt_3:
      "Muéstrame un gráfico de qué proveedores enviaron la mayor cantidad de facturas este mes.",
    prompt_4:
      "Muéstrame un gráfico de cuántos documentos fallaron esta semana.",
    prompt_5: "Ayúdame a hacer una previsión",
  },
  edit_instructions: `Instrucciones de edición`,
  prompts: `Indicaciones`,
  no_further_action_required_mapping: `This mapping is no longer available. Please create a new workflow from Ask Dost.`,
  no_further_action_required_workflow: `This workflow is no longer available. Please create a new workflow from Ask Dost.`,
  proposal_failed: `Esta propuesta no se pudo ejecutar.`,
  proposal_expired: `Esa propuesta ya no está pendiente — es posible que ya se haya decidido.`,
  only_pdf_csv_excel_files_accepted: `Solo se aceptan archivos PDF (máx. 25 MB) y CSV/Excel (máx. 10 MB), con un máximo de 15 archivos en total.`,
  upload: `Subir`,
  browse_files: `Examinar archivos`,
  upload_your_documents: `Sube tus documentos`,
  drag_and_drop_your_files_here: `Arrastra y suelta tus archivos aquí`,
  files_accepted_only: `Solo se aceptan {{acceptedFiles}} archivos`,
  upload_and_manage_support_documents: `Sube y gestiona documentos de soporte`,
  upload_files_for_ask_dost: `Sube archivos para Ask Dost`,
  you_can_attach_files_in_your_prompts_to_ask_dost_for_it_to_analyse_them: `Puedes adjuntar archivos en tus prompts a Ask Dost para que los analice`,
  characters_used: `caracteres usados`,
  offline_error: `Estás desconectado. Comprueba tu conexión a internet e inténtalo de nuevo.`,
  back_online: `Has vuelto a estar en línea.`,
  preferences: `Preferencias`,
  mode: `Modo`,
  saved_prompts: `Prompts guardados`,
  answering_mode: `Modo de respuesta`,
  mode_fast_name: `Rápido`,
  mode_fast_desc: `Respuestas directas sobre tus datos en vivo. Ideal para consultas de estado y búsquedas rápidas.`,
  mode_thinking_name: `Razonamiento`,
  mode_thinking_desc: `Activa el razonamiento profundo — planifica en más pasos antes de responder. Ideal para mapeos, flujos de trabajo y conciliaciones.`,
  thinking_mode_badge: `Modo razonamiento`,
  thinking_mode_on_notice: `Modo razonamiento activado — Dost planifica en más pasos antes de responder.`,
  model: `Modelo`,
  model_auto_name: `Automático`,
  model_auto: `Automático`,
  model_strong: `Potente`,
  model_minimal: `Mínimo`,
  model_recommended: `Recomendado`,
  model_auto_desc: `Dost elige el modelo adecuado para cada solicitud`,
  model_strong_desc: `Razonamiento más profundo — análisis complejo`,
  model_recommended_desc: `Equilibrado (predeterminado)`,
  model_minimal_desc: `El más rápido — solo para tareas simples y básicas`,
  model_haiku_desc: `El más rápido — consultas de estado y preguntas sobre un solo documento.`,
  model_sonnet_desc: `Equilibrio por defecto — mapeos, flujos de trabajo, tablas y gráficos.`,
  model_opus_desc: `Razonamiento más profundo — conciliaciones y análisis en varios pasos sobre muchos documentos.`,
  chat_history: `Historial de chats`,
  hide_history: `Ocultar historial`,
  recent_chats: `Recientes`,
  history_search_placeholder: `Buscar chats`,
  history_no_match: `Ningún chat coincide con "{{query}}"`,
  new_chat_title: `Nuevo chat`,
  chat_n: `Chat {{id}}`,
  chat_deleted_successfully: "Chat eliminado exitosamente",
  unable_to_delete_chat: "No se pudo eliminar el chat",
  rename: `Renombrar`,
  delete: `Eliminar`,
  rename_conversation: `Renombrar chat`,
  chat_renamed_successfully: "Chat renombrado exitosamente",
  unable_to_rename_chat: "No se pudo renombrar el chat",
  dictate: `Dictar`,
  done: `Listo`,
  listening: `Escuchando…`,
  paused: `En pausa`,
  pause: `Pausar`,
  resume: `Reanudar`,
  execution_order: `Orden de ejecución n.º {{n}}`,
  condition_n: `Condición {{n}}`,
  need_changes: `Necesito cambios`,
  create: `Crear`,
  previous: `Anterior`,
  next: `Siguiente`,
  page_of: `{{current}} de {{total}}`,
  draft_n_of_total: `Borrador {{current}} de {{total}}`,
  always: `SIEMPRE`,
  mapping_action_kicker: `ACCIÓN DE MAPEO`,
  approval_action_kicker: `ACCIÓN DE APROBACIÓN`,
  and_connector: `Y`,
  then_connector: `ENTONCES`,
  action_set_prefix: `Establecer`,
  action_to_infix: `a`,
  conditions_kicker: `Condiciones`,
  applied: `Aplicado`,
  none_applies_to_every_document: `Ninguna — se aplica a todos los documentos`,
  mapping_rule_fallback: `Regla de mapeo`,
  applies_to_incoming_documents: `Se aplica a los documentos entrantes`,
  rule_fallback: `Regla`,
  field_fallback: `Campo`,
  set_direct_action: `Establecer valor`,
  formula_action: `Fórmula`,
  map_action: `Mapear`,
  unknown_target_fallback: `Desconocido`,
  show_all_lines: `Ver las {{count}} líneas`,
  download: `Descargar`,
  downloading: `Descargando...`,
  documents_referenced: `Documentos referenciados`,
  unable_to_list_too_many_documents: `No se puede mostrar porque se referenciaron demasiados documentos`,
  output: `Salida`,
  processing: `Procesando`,
  executing_code: `Ejecutando código`,
  code_executed: `Código ejecutado`,
  loading: `Cargando...`,
  NeedApproval: `Requiere aprobación`,
  Approved: `Aprobado`,
  Rejected: `Rechazado`,
  NoApprovalRequired: `No requiere aprobación`,
  execution_complete: `Ejecución completada`,
  sandbox_fallback: `sandbox`,
  save_prompt: `Guardar prompt`,
  saved_to_prompts: `Guardado en prompts`,
  all: `Todo`,
  saved_by_you: `Guardado por ti`,
  dost_suggestions: `Sugerencias de Dost`,
  no_saved_prompts_yet: `Aún no hay prompts guardados. Toca el marcador debajo de un mensaje que enviaste para guardarlo aquí.`,
  remove_saved_prompt: `Quitar prompt guardado`,
  prompt_saved: `Prompt guardado con éxito`,
  prompt_deleted: `Prompt eliminado con éxito`,
  unable_to_save_prompt: `No se pudo guardar el prompt`,
  unable_to_delete_prompt: `No se pudo eliminar el prompt`,
  memories: `Memorias`,
  saved_by_dost: "Ask Dost ha guardado el contexto para poder responderte mejor en futuras conversaciones.",
  clear_all: `Borrar`,
  confirm_delete_message: `¿Estás seguro de que quieres eliminar esto?`,
  delete_conversation_title: `¿Estás seguro de que quieres eliminar este chat?`,
  delete_conversation_message: `Ya no podrás acceder a los prompts ni a las respuestas de este chat.`,
  delete_memory_title: `¿Estás seguro de que quieres eliminar esta memoria?`,
  delete_memory_message: `Esta nota se eliminará de la memoria de Ask Dost y esta acción no se puede deshacer.`,
  delete_prompt_title: `¿Estás seguro de que quieres eliminar este prompt?`,
  delete_prompt_message: `Una vez eliminado, ya no podrás acceder rápidamente a él desde el menú de prompts guardados.`,
  clear_all_memories_title: `¿Estás seguro de que quieres borrar la memoria?`,
  clear_all_memories_message: `Borrar la memoria elimina todo el contexto que Ask Dost ha guardado sobre ti para usar en futuros chats.`,
  no_memories_yet: `Aún no hay memorias. Ask Dost guarda el contexto para poder responderte mejor en futuras conversaciones.`,
  delete_memory: `Eliminar memoria`,
  no_statement_available: `No hay información disponible`,
  last_seen: `Visto por última vez: {{date}}`,
  memory_deleted: `Memoria eliminada`,
  unable_to_delete_memory: `No se pudo eliminar la memoria`,
  memories_cleared: `Memorias borradas`,
  unable_to_clear_memories: `No se pudieron borrar las memorias`,
  vendors: "Proveedores",
  customers: "Clientes",
  invoices: "Facturas",
  bills: "Recibos",
  products: "Productos",
  connectors: `Conectores`,
  erp_connections: `Conexiones ERP`,
  connect: `Conectar`,
  connecting: `Conectando…`,
  sync_now: `Sincronizar ahora`,
  syncing: `Sincronizando…`,
  disconnect: `Desconectar`,
  connected: `Conectado`,
  not_connected: `No conectado`,
  connect_your_odoo_app: `Conecta tu aplicación de Odoo Accounting`,
  last_synced: `Última sincronización {{when}}`,
  just_now: `ahora mismo`,
  more_erp_connectors_coming: `Más conectores ERP están en camino. Ask Dost lee y publica documentos a través de la aplicación conectada.`,
  data_synced: `Datos sincronizados`,
  synced_entity_vendors: `Proveedores`,
  synced_entity_customers: `Clientes`,
  synced_entity_invoices: `Facturas`,
  synced_entity_bills: `Recibos`,
  synced_entity_products: `Productos`,
  synced_entity_purchase_orders: `Órdenes de compra`,
  connect_odoo: `Conectar Odoo`,
  odoo_connect_subtitle: `Usa una clave de API cuando sea posible — se puede revocar sin cambiar la contraseña de la cuenta.`,
  odoo_url: `URL de Odoo`,
  odoo_url_required: `Se requiere la URL de Odoo`,
  invalid_url: `URL inválida`,
  username: `Usuario`,
  api_key_or_password: `Clave de API o contraseña`,
  api_key_required: `Se requiere la clave de API o contraseña`,
  invalid_api_key_or_password: `Clave de API o contraseña inválida`,
  database_name_optional: `Nombre de la base de datos (opcional)`,
  odoo_connect_validation_error: `Completa la URL, el usuario y la clave de API o contraseña.`,
  understanding_your_query: `Entendiendo tu consulta`,
  erp_connection_failed: `Conexión ERP fallida`,
  erp_synced_successfully: `ERP sincronizado con éxito`,
  erp_sync_failed: `Sincronización ERP fallida`,
  erp_disconnected: `ERP desconectado`,
  erp_disconnect_failed: `Desconexión ERP fallida`,
  disconnect_confirm_title: `¿Estás seguro de que quieres desconectar?`,
  disconnect_confirm_message: `Una vez desconectado, no podrás acceder a los datos de este ERP.`,
  connecting_to_erp_title: `Conectando con tu ERP`,
  connecting_to_erp_subtitle: `Ask Dost está trayendo tus registros de Odoo. Esto puede tardar un minuto en bases de datos grandes.`,
  syncing_with_odoo_title: `Sincronizando con Odoo`,
  syncing_with_odoo_subtitle: `Actualizando tus registros de Odoo.`,
  retry: `Reintentar`,
  sync_failed_message: `Error al sincronizar — Odoo no devolvió estos datos. Ask Dost responderá sin ellos.`,
  "odoo_missing_po_model_error": `Este Odoo no tiene el modelo purchase.order — la aplicación que lo proporciona no está instalada, por lo que este conjunto de datos no está disponible aquí.`,
  preview: `Vista previa`,
  no_conversations_found: `No se encontraron conversaciones`,
  ask_dost_greeting: `Hola {{firstName}}, ¿cómo puedo ayudarte hoy?`,
  ask_about_documents: `Pregunta sobre documentos, mapeos, flujos de trabajo o gastos. Los prompts guardados se encuentran bajo el icono de preferencias.`,
  ask_dost_placeholder: `Preguntar a Dost...`,
};
